const entireUS = {
  place_name: 'Entire US',
  id: 'entire-us',
  blacklist: false,
};

export const Geo = {
  entireUS
};
